import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent {
  alt = input<string>('');
  width = input<string>('100%');
  showHTXOnly = input<boolean>(false);

  /**
   * Event emitted when logo is clicked
   */
  logoClick = output<void>();

  onClick(): void {
    this.logoClick.emit();
  }
}
